import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkFlowComponent } from './work-flow.component';
import { VpTemplateDirective } from './vp-template.directive';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        WorkFlowComponent,
        VpTemplateDirective
    ],
    imports: [CommonModule, FormsModule],
    exports: [
        WorkFlowComponent,
        VpTemplateDirective
    ],
    providers: [],
})
export class WorkFlowModule { }
